module.exports = __webpack_public_path__ + "static/meet-concierge-mobile-49003822e141492dff2e42f0805b1561.png";